<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-if="header" v-slot:headerTitle>
            <slot name="headerTitle">
              <h4 class="title-typography-color">
                <i class="fas fa-user-edit"></i>
                {{ $t("public.components.Professional.title") }}
                <b-badge variant="success">Id: {{ id }}</b-badge>
              </h4>
            </slot>
          </template>
          <template v-if="header" v-slot:headerAction>
            <slot name="headerActionMoreBtn"></slot>
            <b-button type="submit" variant="success" @click="saveForm">{{
              $t("public.components.Professional.btnSave")
            }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-alert v-if="validator.errors.length !== 0" show variant="danger">{{
              $t("public.components.Professional.alert.error.validation.body")
            }}
            </b-alert>
            <b-form>
              <form action="#">
                <div class="form-row">
                  <div v-if="admin" class="col-md-12 mb-12">
                    <b-alert v-if="requestValidateRecipe" show variant="danger">{{
                      $t("public.components.Professional.enableToEmit")
                    }}
                    </b-alert>
                    <b-form-group label-for="active">
                      <template slot="label">{{
                        $t("public.components.Professional.validatedToEmit")
                      }}:
                      </template>
                      <b-form-checkbox id="active" v-model="validateRecipe" size="lg" switch
                        @change="changeValidateRecipe"></b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 mb-3">
                    <b-form-group label-for="name">
                      <template slot="label">{{ $t("public.components.Professional.name") }}:
                        *
                      </template>
                      <b-form-input id="nombre" v-model="name" type="text" v-bind:class="{
                        'text-danger': isFormNameErrors,
                        'is-invalid': isFormNameErrors,
                      }" @blur="checkName(name)"></b-form-input>
                      <ul v-if="isFormNameErrors">
                        <li v-for="(error, index) in validator.getErrors('name')" v-bind:key="index"
                          class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="phone">
                      <template slot="label">{{ $t("public.components.Professional.tlf") }}:
                      </template>
                      <VuePhoneNumberInput id="phone" v-model="phoneVuePhoneNumberInput" :translations="translations"
                        v-bind:class="{
                          'text-danger': isFormPhoneErrors,
                          'is-invalid': isFormPhoneErrors,
                        }" @update="updatePhone" />
                      {{ phone }}
                      <ul v-if="isFormPhoneErrors">
                        <li v-for="(error, index) in validatorStep1.getErrors(
                          'phone'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-row>
                      <div class="col-md-8">
                        <b-form-group>
                          <template slot="label">{{ $t("public.components.Professional.image") }}:
                          </template>
                          <vue-dropzone id="picture" :options="dropzoneOptions"
                            @vdropzone-success="vdropzoneSuccess"></vue-dropzone>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 img-center">
                        <img v-if="defaultAvatar" :src="file" class="img-fluid rounded mr-3" height="150px"
                          width="150px" />
                        <img v-else class="img-fluid rounded mr-3" height="150px"
                          v-bind:src="'data:image/jpeg;base64,' + file" width="150px" />
                      </div>
                    </b-row>
                  </div>
                  <div class="col-md-6 mb-3">
                    <b-form-group label-for="lastname">
                      <template slot="label">{{ $t("public.components.Professional.lastname") }}:
                        *
                      </template>
                      <b-form-input id="lastname" v-model="lastname" type="text" v-bind:class="{
                        'text-danger': isFormLastnameErrors,
                        'is-invalid': isFormLastnameErrors,
                      }" @blur="checkLastname(lastname)"></b-form-input>
                      <ul v-if="isFormLastnameErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'lastname'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label="Email: *" label-for="email">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span id="emailDecorate" class="input-group-text">@</span>
                        </div>
                        <b-form-input id="email" v-model="email" type="email" v-bind:class="{
                          'text-danger': isFormEmailErrors,
                          'is-invalid': isFormEmailErrors,
                        }" @blur="checkEmail(email)"></b-form-input>
                      </div>
                      <ul v-if="isFormEmailErrors">
                        <li v-for="(error, index) in validator.getErrors('email')" v-bind:key="index"
                          class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <!--             <b-form-group
                      size="sm"
                      class="mb-3"
                      v-if="validateRecipeCode !== true"
                    >
                      <b-form-group label-for="domainEmail">
                        <template slot="label">Email para gestionar recetas:</template>
                        <b-input-group>
                          <b-form-input
                            id="domainEmailName"
                            v-model="domainEmailName"
                            type="text"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-select
                              id="domainEmailHost"
                              v-model="domainEmailHost"
                              class="select-account-recipes"
                              :options="domainEmails"
                              type="text"
                            ></b-form-select>
                            <b-button
                              @click="sendCodeRecipe"
                              size="sm"
                              text="Button"
                              variant="primary"
                              :disabled="domainEmailName == '' || !domainEmailHost"
                            >Enviar</b-button>
                          </b-input-group-append>
                        </b-input-group>

                      </b-form-group>
                      <b-form-group
                        label-for="domainEmailName"
                        v-if="codeRecipeRetry && codeRecipeRetry > 0"
                      >
                        <template slot="label">Código para gestionar recetas:</template>
                        <b-input-group>
                          <the-mask
                            id="code"
                            v-model="code"
                            class="form-control"
                            type="text"
                            mask="####"
                          />
                          <b-input-group-append class="border borde-left-0">
                            <span class="ml-1 mr-1">Intentos: {{codeRecipeRetry}}</span>
                            <b-button
                              @click="validateCodeRecipe"
                              size="sm"
                              text="Button"
                              variant="primary"
                              :disabled="code.length !== 4"
                            >Validar código</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>

                    </b-form-group>
                    <div v-else>
                      <b-alert
                        variant="success"
                        show
                      >El profesional fue verificado para acceder al módulo de recetas con el email: {{domainEmailName + domainEmailHost}}</b-alert>
                    </div>
                    -->
                    <b-form-group label-for="document">
                      <template slot="label">{{ $t("public.components.Professional.document") }}:
                      </template>
                      <b-form-input id="document" v-model="document" type="text" v-bind:class="{
                        'text-danger': isFormDocumentErrors,
                        'is-invalid': isFormDocumentErrors,
                      }"></b-form-input>
                      <ul v-if="isFormDocumentErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'document'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="idioma">
                      <template slot="label">{{ $t("public.components.Professional.language") }}:
                      </template>
                      <b-select id="language" v-model="language" :options="languageSelect" class="form-control"
                        v-bind:class="{
                          'text-danger': isFormLanguageErrors,
                          'is-invalid': isFormLanguageErrors,
                        }">
                      </b-select>
                      <ul v-if="isFormLanguageErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'language'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 mb-3">
                    <b-form-group label-for="country">
                      <template slot="label">{{ $t("public.components.Professional.country") }}:
                      </template>
                      <b-form-input id="country" v-model="country" type="text" v-bind:class="{
                        'text-danger': isFormCountryErrors,
                        'is-invalid': isFormCountryErrors,
                      }" @blur="checkCountry(country)"></b-form-input>
                      <ul v-if="isFormCountryErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'country'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
           <!--         <b-form-group label-for="province">
                      <template slot="label">{{ $t("public.components.Professional.province") }}:
                      </template>
                      <b-form-input id="province" v-model="province" type="text" v-bind:class="{
                        'text-danger': isFormCountryErrors,
                        'is-invalid': isFormCountryErrors,
                      }"></b-form-input>
                      <ul v-if="isFormCountryErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'province'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group> -->
                    <b-form-group label-for="address">
                      <template slot="label">{{ $t("public.components.Professional.address") }}:
                      </template>
                      <b-input v-model="address" class="form-control" v-bind:class="{
                        'text-danger': isFormAddressErrors,
                        'is-invalid': isFormAddressErrors,
                      }" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Contact.Contacts.placeHolder.writeAddress'
  )
"></b-input>
                      <ul v-if="isFormAddressErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'address'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="emailSummary">
                      <template slot="label">{{
                        $t("public.components.Professional.emailSummary")
                      }}:
                      </template>
                      <b-form-radio-group id="emailSummary" v-model="emailSummary">
                        <b-form-radio value="true">{{
                          $t("generic.yes")
                        }}
                        </b-form-radio>
                        <b-form-radio value="false">{{
                          $t("generic.no")
                        }}
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group label-for="password">
                      <template slot="label">{{ $t("public.components.Professional.pwd") }}:
                      </template>
                      <b-form-input id="password" v-model="password" type="password" v-bind:class="{
                        'text-danger': isFormPasswordErrors,
                        'is-invalid': isFormPasswordErrors,
                      }" @blur="checkPassword(password)"></b-form-input>
                      <ul v-if="isFormPasswordErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'password'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="passwordConfirm">
                      <template slot="label">{{ $t("public.components.Professional.pwdConfirm") }}:
                      </template>
                      <b-form-input id="passwordConfirm" v-model="passwordConfirm" type="password" v-bind:class="{
                        'text-danger': isFormPasswordConfirmErrors,
                        'is-invalid': isFormPasswordConfirmErrors,
                      }" @blur="checkPasswordConfirm(passwordConfirm, password)"></b-form-input>
                      <ul v-if="isFormPasswordConfirmErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'passwordConfirm'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 mb-3">
                   <!-- <b-form-group label-for="city">
                      <template slot="label">{{ $t("public.components.Professional.city") }}:
                      </template>
                      <b-form-input id="city" v-model="city" type="text" v-bind:class="{
                        'text-danger': isFormCityErrors,
                        'is-invalid': isFormCityErrors,
                      }"></b-form-input>
                      <ul v-if="isFormCityErrors">
                        <li v-for="(error, index) in validator.getErrors('city')" v-bind:key="index"
                          class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group> -->
                    <b-form-group label-for="postalCode">
                      <template slot="label">{{ $t("public.components.Professional.postalCode") }}:
                      </template>
                      <b-form-input id="postalCode" v-model="postalCode" type="text" v-bind:class="{
                        'text-danger': isFormPostalCodeErrors,
                        'is-invalid': isFormPostalCodeErrors,
                      }"></b-form-input>
                      <ul v-if="isFormPostalCodeErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'postalCode'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="timeZone">
                      <template slot="label">{{ $t("public.components.Professional.timeZone") }}:
                      </template>
                      <b-select id="timeZone" v-model="timeZone" :options="timeZoneSelect" class="form-control"
                        v-bind:class="{
                          'text-danger': isFormTimeZoneErrors,
                          'is-invalid': isFormTimeZoneErrors,
                        }">
                      </b-select>
                      <ul v-if="isFormTimeZoneErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'timeZone'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="speciality">
                      <template slot="label">{{ $t("public.components.Professional.speciality") }}:
                      </template>
                      <b-form-input id="speciality" v-model="speciality" type="text"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="memberId">
                      <template slot="label">{{ $t("public.components.Professional.memberId") }}:
                      </template>
                      <the-mask id="memberId" v-model="memberId" class="form-control" mask="#########" type="text" />
                    </b-form-group>

                    <b-row>
                      <div class="col-md-8">
                        <b-form-group>
                          <template slot="label">{{
                            $t(
                                                      "public.components.Professional.imageSignature"
                            )
                          }}:
                          </template>
                          <vue-dropzone id="pictureSignature" :options="dropzoneOptionsSignature"
                            @vdropzone-success="vdropzoneSuccessSignature"></vue-dropzone>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 img-center">
                        <img v-if="defaultAvatarSignature" :src="fileSignature" class="img-fluid rounded mr-3"
                          height="150px" width="150px" />
                        <img v-else class="img-fluid rounded mr-3" height="150px"
                          v-bind:src="'data:image/jpeg;base64,' + fileSignature" width="150px" />
                      </div>
                    </b-row>
                    <b-row>
                      <div class="col-md-8">
                        <b-form-group>
                          <template slot="label">{{
                            $t(
                                                      "public.components.Professional.imageDocumentMember"
                            )
                          }}:
                          </template>
                          <vue-dropzone id="pictureDocumentMember" :options="dropzoneOptionsDocumentMember"
                            @vdropzone-success="vdropzoneSuccessDocumentMember"></vue-dropzone>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 img-center">
                        <img v-if="defaultAvatarDocumentMember" :src="fileDocumentMember" class="img-fluid rounded mr-3"
                          height="150px" width="150px" />
                        <img v-else class="img-fluid rounded mr-3" height="150px" v-bind:src="
                          'data:image/jpeg;base64,' + fileDocumentMember
                        " width="150px" />
                      </div>
                    </b-row>
                  </div>
                  <div class="col-md-6 mb-3">
                    *{{ $t("public.components.Professional.required") }}
                  </div>
                  <div v-if="!admin" class="col-md-6 mb-3">
                    <div v-if="!validateRecipe">
                      <div v-if="!requestValidateRecipe">
                        <b-button v-if="
                          memberId &&
                          uuidDocumentMember &&
                          uuidSignature &&
                          speciality
                        " variant="success" @click="sendRequestActivateRecipe">{{
  $t("public.components.Professional.btnValidate")
}}
                        </b-button>
                        <b-alert v-else-if="!uuidSignature" show>{{
                          $t(
                                                  "public.components.Professional.alert.error.validation.needSignature"
                          )
                        }}
                        </b-alert>
                        <b-alert v-else-if="!uuidDocumentMember" show>{{
                          $t(
                                                  "public.components.Professional.alert.error.validation.needPhoto"
                          )
                        }}
                        </b-alert>
                        <b-alert v-else-if="!memberId" show>{{
                          $t(
                                                  "public.components.Professional.alert.error.validation.needDoctorNumber"
                          )
                        }}
                        </b-alert>
                        <b-alert v-else-if="!speciality" show>{{
                          $t(
                                                  "public.components.Professional.alert.error.validation.needSpeciality"
                          )
                        }}
                        </b-alert>
                      </div>
                      <div v-else>
                        <b-alert show>{{
                          $t(
                                                  "public.components.Professional.alert.error.validation.validating"
                          )
                        }}
                        </b-alert>
                      </div>
                    </div>
                    <div v-else>
                      <b-alert show variant="success">{{
                        $t(
                      "public.components.Professional.alert.error.validation.validationSuccess"
                        )
                      }}
                      </b-alert>
                    </div>
                  </div>
                </div>
              </form>
            </b-form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import routes from "../../router/index";

import { xray } from "../../config/pluginInit";

import TimeZone from "../../services/timeZone";
import Language from "../../json/Language";

import validator from "vue-m-validator";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import professionalService from "../../services/professional";
import utilsService from "../../services/utils";
import userService from "../../services/user";
import domainEmailService from "../../services/domainEmail";

export default {
  name: "AccountProfessional",
  props: {
    professionalId: {},
    admin: {
      type: Boolean,
      default: false,
    },
    header: {
      type: Boolean,
      default: true,
    },
    oldPassword: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    xray.index();
    this.getProfessional();
    this.getAllDomainEmails();
  },
  components: {
    VuePhoneNumberInput,
    "vue-dropzone": vue2Dropzone,
  },
  data() {
    return {
      //Data validate form
      isFirstRun: true,
      isValidate: false,
      emailInUse: false,
      //Data form
      id: "",
      organizationId: "",
      name: "",
      phone: "",
      phoneVuePhoneNumberInput: "",
      lastname: "",
      //Es usado para desloguear en caso de que sea el email
      emailOriginal: "",
      email: "",
      emailRecipe: "",
      document: "",
      country: "",
      speciality: "",
      province: "",
      address: "",
      language: "",
      timeZone: "",
      city: "",
      postalCode: "",
      password: "",
      passwordConfirm: "",
      passwordOld: "",
      filename: "",
      filenameSignature: "",
      uuid: "",
      uuidSignature: "",
      uuidDocumentMember: "",
      validateRecipe: false,
      requestValidateRecipe: false,
      //others
      emailSummary: false,
      memberId: "",
      domainEmails: [],
      domainEmailHost: "",
      domainEmailName: "",
      code: "",
      //--
      //Translations phone
      translations: {
        countrySelectorLabel: this.$i18n.t(
          "generic.phone.countrySelectorLabel"
        ),
        countrySelectorError: this.$i18n.t(
          "generic.phone.countrySelectorError"
        ),
        phoneNumberLabel: this.$i18n.t("generic.phone.phoneNumberLabel"),
        example: this.$i18n.t("generic.phone.example"),
      },
      validator: validator,
      //Load select
      timeZoneSelect: TimeZone,
      languageSelect: Language,
      activitySectorSelect: [],
      //Avatar
      file: "",
      defaultAvatar: true,
      //Signature
      fileSignature: "",
      defaultAvatarSignature: true,

      //Signature
      fileDocumentMember: "",
      defaultAvatarDocumentMember: true,

      codeRecipeRetry: 0,
      validateRecipeCode: false,

      //Form image
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      dropzoneOptionsSignature: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      dropzoneOptionsDocumentMember: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
    };
  },
  methods: {
    validateCodeRecipe() {
      let self = this;

      let professionalId = this.professionalId
        ? this.professionalId
        : localStorage.getItem("userId");

      this.$awn.asyncBlock(
        domainEmailService.validateCode(this.code, professionalId),
        (response) => {
          if (response && response.data) {
            self.getProfessional();
            self.$swal(
              "Se ha validado correctamente el email",
              "Ya puede utilizar el módulo de recetas",
              "success"
            );
          }
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            self.getProfessional();
            self.$swal(
              "Código erroneo",
              "Le quedan " + (this.codeRecipeRetry - 1) + " intentos.",
              "error"
            );
          } else {
            utilsService.auditErrorFrontent({
              info: "domainEmailService.validateCode",
              module: "component-account-professional",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({ code: self.code, professional: professionalId }),
            });
          }
        },
        " "
      );
    },
    sendCodeRecipe() {
      let self = this;

      let data = {
        professionalId: this.professionalId
          ? this.professionalId
          : localStorage.getItem("userId"),
        name: this.domainEmailName,
        host: this.domainEmailHost,
      };

      this.$awn.asyncBlock(
        domainEmailService.createCode(data),
        (response) => {
          if (response && response.data) {
            this.getProfessional();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "domainEmailService.createCode",
            module: "component-account-professional",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify(data),
          });
        },
        " "
      );
    },
    async getAllDomainEmails() {
      let self = this;

      domainEmailService
        .getAllPagination(0, 100)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.content &&
            response.data.content.length > 0
          ) {
            let domain = [];

            response.data.content.forEach(function (item) {
              domain.push({ value: item.value, text: item.value });
            });

            self.domainEmails = domain;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "domainEmailService.getAllPagination",
            module: "component-account-professional",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        });
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    sendRequestActivateRecipe() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.requestActivateRecipe(this.id),
        (response) => {
          if (response) {
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.Professional.notifications.error"
              ),
              text: this.$i18n.t(
                "public.components.Professional.notifications.sendEmitionRequest"
              ),
              type: "success",
            });
            self.getProfessional();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.requestActivateRecipe",
            module: "component-account-professional",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: this.id,
          });
        },
        " "
      );
    },
    changeValidateRecipe() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.activateRecipe(this.id, this.validateRecipe),
        (response) => {
          if (response) {
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.Professional.notifications.title"
              ),
              text: this.$i18n.t(
                "public.components.Professional.notifications.desc"
              ),
              type: "success",
            });
            self.getProfessional();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.activateRecipe",
            module: "component-account-professional",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ id: this.id, validateRecipe: this.validateRecipe }),
          });
        },
        " "
      );
    },
    getCheckEmail(email) {
      let self = this;
      utilsService
        .checkEmail(email)
        .then((response) => {
          if (response) {
            self.emailInUse = response.data;
            //  self.checkEmail(this.email);
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t("public.components.Professional.errors.erName"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkPhone(_phone) {
      const PHONE = _phone.trim();
      const RULE_1 = {
        expression: !PHONE || PHONE === "",
        name: "phone",
        msg: this.$i18n.t("public.components.Professional.errors.erPhone"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkBirthday(_birthday) {
      const BIRTHDAY = _birthday.trim();
      const RULE_1 = {
        expression: !BIRTHDAY || BIRTHDAY === "",
        name: "birthday",
        msg: this.$i18n.t("public.components.Professional.errors.erBirth"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkLastname(_lastname) {
      const LASTNAME = _lastname.trim();
      const RULE_1 = {
        expression: !LASTNAME || LASTNAME === "",
        name: "lastname",
        msg: this.$i18n.t("public.components.Professional.errors.erLastName"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkEmail(_email) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t("public.components.Professional.errors.erMail1"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t("public.components.Professional.errors.erMail2"),
      };

      if (EMAIL !== this.emailOriginal) {
        const RULE_3 = {
          expression: this.emailInUse,
          name: "email",
          msg: this.$i18n.t("public.components.Professional.errors.erMail3"),
        };
        validator.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      } else {
        validator.addRule(RULE_1).addRule(RULE_2);
      }
      this.notFirst();
    },
    checkDocument(_document) {
      const DOCUMENT = _document.trim();
      const RULE_1 = {
        expression: !DOCUMENT || DOCUMENT === "",
        name: "document",
        msg: this.$i18n.t("public.components.Professional.errors.erDocument"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkSpeciality(_specialty) {
      const SPECIALITY = _specialty.trim();
      const RULE_1 = {
        expression: !SPECIALITY || SPECIALITY === "",
        name: "speciality",
        msg: this.$i18n.t("public.components.Professional.errors.erSpeciality"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkCountry(_country) {
      const COUNTRY = _country.trim();
      const RULE_1 = {
        expression: !COUNTRY || COUNTRY === "",
        name: "country",
        msg: this.$i18n.t("public.components.Professional.errors.erCountry"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkProvince(_province) {
      const PROVINCE = _province.trim();
      const RULE_1 = {
        expression: !PROVINCE || PROVINCE === "",
        name: "province",
        msg: this.$i18n.t("public.components.Professional.errors.erProvince"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkAddress(_address) {
      const ADDRESS = _address.trim();
      const RULE_1 = {
        expression: !ADDRESS || ADDRESS === "",
        name: "address",
        msg: this.$i18n.t("public.components.Professional.errors.erAdress"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkTimeZone(_timeZone) {
      const TIMEZONE = _timeZone.trim();
      const RULE_1 = {
        expression: !TIMEZONE || TIMEZONE === "",
        name: "timeZone",
        msg: this.$i18n.t("public.components.Professional.errors.erTimeZone"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkCity(_city) {
      const CITY = _city.trim();
      const RULE_1 = {
        expression: !CITY || CITY === "",
        name: "city",
        msg: this.$i18n.t("public.components.Professional.errors.erCity"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkPostalCode(_postalCode) {
      const POSTALCODE = _postalCode.trim();
      const RULE_1 = {
        expression: !POSTALCODE || POSTALCODE === "",
        name: "postalCode",
        msg: this.$i18n.t("public.components.Professional.errors.erPostalCode"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkLanguage(_language) {
      const LANGUAGE = _language.trim();
      const RULE_1 = {
        expression: !LANGUAGE || LANGUAGE === "",
        name: "language",
        msg: this.$i18n.t("public.components.Professional.errors.erLenguage"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkPasswordOld(_password) {
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORD || PASSWORD === "",
        name: "passwordOld",
        msg: this.$i18n.t("public.components.Professional.errors.erPwd"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORD),
        name: "passwordOld",
        msg: this.$i18n.t("public.components.Professional.errors.erPwd2"),
      };
      validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkPassword(_password) {
      const PASSWORD = _password.trim();

      if (PASSWORD && PASSWORD !== "") {
        /* eslint-disable-next-line */
        const RULE_1_REGEXP = new RegExp(
          "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
        );
        const RULE_1 = {
          expression: !RULE_1_REGEXP.test(PASSWORD),
          name: "password",
          msg: this.$i18n.t("public.components.Professional.errors.erPwd2"),
        };
        validator.addRule(RULE_1);
      }
      this.notFirst();
    },
    checkPasswordConfirm(_passwordConfirm, _password) {
      const PASSWORDCONFIRM = _passwordConfirm.trim();
      const PASSWORD = _password.trim();

      if (PASSWORDCONFIRM && PASSWORDCONFIRM !== "") {
        /* eslint-disable-next-line */
        const RULE_1_REGEXP = new RegExp(
          "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
        );
        const RULE_1 = {
          expression: !RULE_1_REGEXP.test(PASSWORDCONFIRM),
          name: "passwordConfirm",
          msg: this.$i18n.t("public.components.Professional.errors.erPwd2"),
        };

        const RULE_2 = {
          expression: PASSWORDCONFIRM !== PASSWORD,
          name: "passwordConfirm",
          msg: this.$i18n.t(
            "public.components.Professional.errors.erPwdConfirm"
          ),
        };
        validator.addRule(RULE_1).addRule(RULE_2);
      }
      this.notFirst();
    },
    checkForm() {
      this.checkName(this.name);
      //  this.checkPhone(this.phone);
      //  this.checkBirthday(this.birthday);
      this.checkLastname(this.lastname);
      this.checkEmail(this.email);
      //   this.checkDocument(this.document);
      //    this.checkCountry(this.country);
      //   this.checkProvince(this.province);
      //   this.checkAddress(this.address);
      //   this.checkTimeZone(this.timeZone);
      //   this.checkCity(this.city);
      //  this.checkPostalCode(this.postalCode);
      if (this.oldPassword) {
        this.checkPasswordOld(this.passwordOld);
      }
      this.checkPassword(this.password);
      this.checkPasswordConfirm(this.passwordConfirm, this.password);
    },
    saveForm() {
      let self = this;

      self
        .$swal({
          title: this.$i18n.t("public.components.Professional.passwordOld"),
          input: "password",
          inputAttributes: {
            maxlength: 50,
            autocapitalize: "off",
            autocorrect: "off",
          },
          showCancelButton: true,
          confirmButtonText: this.$i18n.t(
            "public.components.Professional.btnSave"
          ),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.passwordOld = result.value;
            let data = {
              password: self.passwordOld,
            };
            userService
              .checkPassword(data)
              .then((response) => {
                if (response && response.data) {
                  self.checkForm();
                  if (self.validator.errors.length === 0) {
                    self.updateProfessional();
                  } else {
                    self.$notify({
                      group: "notificacions",
                      title: self.$i18n.t(
                        "public.components.Professional.notifications.error"
                      ),
                      text: self.$i18n.t(
                        "public.components.Professional.notifications.errorsDetected"
                      ),
                      type: "error",
                    });
                  }
                } else {
                  self.$swal({
                    icon: "error",
                    title: "Oops...",
                    text: self.$i18n.t("generic.checkPasswordIncorrect"),
                  });
                }
              })
              .catch(function (error) {
                utilsService.auditErrorFrontent({
                  info: "userService.checkPassword",
                  module: "component-account-professional",
                  httpStatus: error.response ? error.response.status : null,
                  endpoint: window.location.href,
                  request: JSON.stringify(data),
                });
              });
          }
        });
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData.route;
      this.country = addressData.country;
      this.city = addressData.locality;
      this.postalCode = addressData.postal_code;
      this.province = addressData.administrative_area_level_1;
    },
    updateAddress(data) {
      this.address = data.newVal;
    },
    vdropzoneSuccess: function (file, response) {
      this.uuid = response.uuid;
      this.filename = response.name;
      this.getFile(this.uuid);
    },
    vdropzoneSuccessSignature: function (file, response) {
      this.uuidSignature = response.uuid;
      this.filenameSignature = response.name;
      this.getFileSignature(this.uuidSignature);
    },
    vdropzoneSuccessDocumentMember: function (file, response) {
      this.uuidDocumentMember = response.uuid;
      this.filenameDocumentMember = response.name;
      this.getFileDocumentMember(this.uuidDocumentMember);
    },
    async getFile(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatar = false;
            self.file = response.data.data;
          } else {
            self.defaultAvatar = true;
            self.file = require("../../assets/images/user/woman_profile.jpg");
          }
        })
        .catch(function (error) {
          self.defaultAvatar = true;
          self.file = require("../../assets/images/user/woman_profile.jpg");
        });
    },
    async getFileSignature(uuidSignature) {
      let self = this;
      utilsService
        .getFile(uuidSignature)
        .then((response) => {
          if (response) {
            self.defaultAvatarSignature = false;
            self.fileSignature = response.data.data;
          } else {
            self.defaultAvatarSignature = true;
            self.fileSignature = require("../../assets/images/signature/no_signature.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatarSignature = true;
          self.fileSignature = require("../../assets/images/signature/no_signature.png");
        });
    },
    async getFileDocumentMember(uuidDocumentMember) {
      let self = this;
      utilsService
        .getFile(uuidDocumentMember)
        .then((response) => {
          if (response) {
            self.defaultAvatarDocumentMember = false;
            self.fileDocumentMember = response.data.data;
          } else {
            self.defaultAvatarDocumentMember = true;
            self.fileDocumentMember = require("../../assets/images/carnet/no_carnet.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatarDocumentMember = true;
          self.fileDocumentMember = require("../../assets/images/carnet/no_carnet.png");
        });
    },
    async getProfessional() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.get(this.professionalId),
        (response) => {
          if (response) {
            self.id = response.data.id;
            self.name = response.data.name;
            self.phone = response.data.phone;
            self.phoneVuePhoneNumberInput = response.data.phone;
            self.lastname = response.data.lastname;
            self.emailOriginal = response.data.email;
            self.email = response.data.email;
            self.language = response.data.language;
            self.document = response.data.document;
            self.country = response.data.country;
            self.province = response.data.province;
            self.address = response.data.address;
            self.timeZone = response.data.timeZone;
            self.city = response.data.city;
            self.postalCode = response.data.postalCode;
            self.filename = response.data.filename;
            self.filenameSignature = response.data.filenameSignature;
            self.filenameDocumentMember = response.data.filenameDocumentMember;
            self.uuid = response.data.uuid;
            self.uuidSignature = response.data.uuidSignature;
            self.uuidDocumentMember = response.data.uuidDocumentMember;
            self.emailSummary = response.data.emailSummary;
            self.memberId = response.data.memberId;
            self.organizationId = response.data.organizationId;
            self.validateRecipe = response.data.validateRecipe;
            self.requestValidateRecipe = response.data.requestValidateRecipe;
            self.speciality = response.data.speciality;
            self.codeRecipeRetry = response.data.codeRecipeRetry;
            self.validateRecipeCode = response.data.validateRecipeCode;

            if (response.data.emailRecipe) {
              self.domainEmailHost = self.getHostByEmail(
                response.data.emailRecipe
              );
              self.domainEmailName = self.getNameByEmail(
                response.data.emailRecipe
              );
            }

            self.getFile(self.uuid);
            self.getFileSignature(self.uuidSignature);
            self.getFileDocumentMember(self.uuidDocumentMember);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.get",
            module: "component-account-professional",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ professionalId: this.professionalId }),
          });
        },
        " "
      );
    },
    getHostByEmail(email) {
      let last = email.indexOf("@");

      return email.substring(last, email.length);
    },
    getNameByEmail(email) {
      let last = email.indexOf("@");

      return email.substring(0, last);
    },
    updateProfessional() {
      let self = this;
      let profesional = {
        id: this.professionalId,
        email: this.email,
        password: this.password,
        passwordConfirm: this.passwordConfirm,
        passwordOld: this.passwordOld,
        name: this.name,
        lastname: this.lastname,
        language: this.language,
        document: this.document,
        language: this.language,
        phone: this.phone,
        country: this.country,
        address: this.address,
        timeZone: this.timeZone,
        city: this.city,
        province: this.province,
        postalCode: this.postalCode,
        filename: this.filename,
        filenameSignature: this.filenameSignature,
        filenameDocumentMember: this.filenameDocumentMember,
        uuid: this.uuid,
        uuidSignature: this.uuidSignature,
        uuidDocumentMember: this.uuidDocumentMember,
        emailSummary: this.emailSummary,
        memberId: this.memberId,
        speciality: this.speciality,
      };

      this.$awn.asyncBlock(
        professionalService.update(profesional),
        (response) => {
          if (self.email === self.emailOriginal) {
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.Professional.notifications.title"
              ),
              text: this.$i18n.t(
                "public.components.Professional.notifications.changesSaved"
              ),
              type: "success",
            });
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_MY_ACCOUNT", info: "" });
          } else {
            self.logout();
          }
        },
        (error) => {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.Professional.notifications.error"
            ),
            text: this.$i18n.t(
              "public.components.Professional.notifications.errorPwdIncorrect"
            ),
            type: "error",
          });
        },
        " "
      );
    },
    logout() {
      utilsService.auditActivity({ action: "CREATE", module: "AUTH_LOGOUT", info: "" });

      localStorage.removeItem("organizationRoles");
      localStorage.removeItem("authorization");
      localStorage.removeItem("organizationId");
      localStorage.removeItem("type");
      localStorage.removeItem("userId");

      this.$router.push({ name: "public.signin" });
    },
    updatePhone(data) {
      this.phone = data.e164;
    },
  },
  computed: {
    //Validate form
    isDisabled() {
      return this.isFirstRun === true || this.validator.errors.length > 0;
    },
    isFormNameErrors() {
      let errors = this.validator.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormPhoneErrors() {
      let errors = this.validator.getErrors("phone");
      return errors && errors.length > 0;
    },
    isFormLastnameErrors() {
      let errors = this.validator.getErrors("lastname");
      return errors && errors.length > 0;
    },
    isFormEmailErrors() {
      if (this.email !== this.emailOriginal) {
        const RULE_2_REGEXP = new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        );
        if (RULE_2_REGEXP.test(this.email)) {
          this.getCheckEmail(this.email);
        }
      }
      let errors = this.validator.getErrors("email");
      return errors && errors.length > 0;
    },
    isFormDocumentErrors() {
      let errors = this.validator.getErrors("document");
      return errors && errors.length > 0;
    },
    isFormLanguageErrors() {
      let errors = this.validator.getErrors("language");
      return errors && errors.length > 0;
    },
    isFormSpecialityErrors() {
      let errors = this.validator.getErrors("speciality");
      return errors && errors.length > 0;
    },
    isFormCountryErrors() {
      let errors = this.validator.getErrors("country");
      return errors && errors.length > 0;
    },
    isFormAddressErrors() {
      let errors = this.validator.getErrors("address");
      return errors && errors.length > 0;
    },
    isFormTimeZoneErrors() {
      let errors = this.validator.getErrors("timeZone");
      return errors && errors.length > 0;
    },
    isFormCityErrors() {
      let errors = this.validator.getErrors("city");
      return errors && errors.length > 0;
    },
    isFormPostalCodeErrors() {
      let errors = this.validator.getErrors("postalCode");
      return errors && errors.length > 0;
    },
    isFormPasswordOldErrors() {
      let errors = this.validator.getErrors("passwordOld");
      return errors && errors.length > 0;
    },
    isFormPasswordErrors() {
      let errors = this.validator.getErrors("password");
      return errors && errors.length > 0;
    },
    isFormPasswordConfirmErrors() {
      let errors = this.validator.getErrors("passwordConfirm");
      return errors && errors.length > 0;
    },
  },
};
</script>
